module.exports = __webpack_public_path__ + "img/maizeGDB.9cd9ce28.png";